import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'Nasıl Çalışır', href: '#nasil-calisir' },
  { label: 'Terapistler İçin', href: '#terapistler-icin' },
  { label: 'Spa İşletmeleri İçin', href: '#spa-isletmeleri-icin' },
  { label: 'Güvenlik', href: '#guvenlik' },
  { label: 'SSS', href: '#sss' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-soft'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 text-deep-navy-500 font-bold text-lg md:text-xl tracking-tight"
          >
            <span className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-dark-teal-500 flex items-center justify-center text-white text-sm font-bold">
              S
            </span>
            <span className="font-sans">SpaProBridge</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-sm font-medium text-deep-navy-400 hover:text-dark-teal-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={() => navigate('/terapist-kayit')}
              className="px-4 py-2.5 rounded-full text-sm font-semibold text-dark-teal-500 border border-dark-teal-500 hover:bg-dark-teal-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Terapist Olarak Katıl
            </button>
            <button
              onClick={() => navigate('/spa-kayit')}
              className="px-4 py-2.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Spa İşletmesi Başvurusu
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-deep-navy-500 cursor-pointer"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-left px-4 py-3 text-sm font-medium text-deep-navy-400 hover:text-dark-teal-500 hover:bg-off-white rounded-lg transition-colors cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <div className="mt-3 flex flex-col gap-2">
              <button
                onClick={() => {
                  setMobileOpen(false);
                  navigate('/terapist-kayit');
                }}
                className="w-full px-4 py-3 rounded-full text-sm font-semibold text-dark-teal-500 border border-dark-teal-500 hover:bg-dark-teal-50 transition-colors cursor-pointer"
              >
                Terapist Olarak Katıl
              </button>
              <button
                onClick={() => {
                  setMobileOpen(false);
                  navigate('/spa-kayit');
                }}
                className="w-full px-4 py-3 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
              >
                Spa İşletmesi Başvurusu
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}